export const GET_STUDENT_DETAILS = "GET_STUDENT_DETAILS";
export const GET_ALL_APPOINTMENTS = "GET_ALL_APPOINTMENTS";
